import React from 'react';
import * as Yup from 'yup';
import { Formik } from "formik";

const validationSchema = Yup.object({
    nombre: Yup.string(),
    f_inicio: Yup.date(),
    f_fin: Yup.date(),
    estatus: Yup.string()
});


export default function FiltroSorteo(props) {
    const { Filter } = props;
    return (
        <Formik
            initialValues={{
                nombre: '',
                f_inicio: '',
                f_fin: '',
                estatus: ''
            }}
            validationSchema={validationSchema}
            enableReinitialize="true"
            onSubmit={(values, actions) => {
                Filter(values, actions);
            }}>
            {({
                values,
                errors,
                status,
                setFieldValue,
                handleBlur,
                handleChange,
                handleSubmit,
                resetForm
            }) => <form onSubmit={handleSubmit} autoComplete="off" >
                    <div className='row'>
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1">Nombre:</label>
                                <input type="text" name='nombre' className='form-control form-control-sm' value={values.nombre || ''} onChange={handleChange} />
                                <span className="help-block">{errors.nombre}</span>
                            </div>
                        </div>
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1">Fecha Inicio:</label>
                                <input type="date" name='f_inicio' className='form-control form-control-sm' value={values.f_inicio || ''} onChange={handleChange} />
                                <span className="help-block">{errors.f_inicio}</span>
                            </div>
                        </div>
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1">Fecha Fin:</label>
                                <input type="date" name='f_fin' className='form-control form-control-sm' value={values.f_fin || ''} onChange={handleChange} />
                                <span className="help-block">{errors.f_fin}</span>
                            </div>
                        </div>
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1">Estatus:</label>
                                <select name="estatus" id="estatus" className='form-select form-select-sm' value={values.estatus || ''} onChange={handleChange}>
                                    <option value="">Seleccione uno</option>
                                    <option value="ACTIVO">ACTIVO</option>
                                    <option value="FIN CAPTURA">FIN CAPTURA</option>
                                    <option value="FINALIZADO">FINALIZADO</option>
                                </select>
                                <span className="help-block">{errors.estatus}</span>
                            </div>
                        </div>
                        <div className="col-sm-2 col-md-2 col-lg-2">
                            <div className="form-group" style={{ paddingTop: '30px' }}>
                                <button type='submit' className='btn btn-sm mt-30 text-white' style={{ background: "#E6453B" }}>Buscar</button>
                            </div>
                        </div>
                    </div>
                </form>
            }
        </Formik>
    )
}
